import React, { useState } from 'react';

import { MapaGrupo } from 'types/Relatorios/Decomp';
import './index.scss';

/**
 * Galeria de mapas com sub-abas por grupo (ex.: Dados Observados / Climatologia /
 * Anomalia). Componente apresentacional: recebe os grupos por props (sem chamada
 * de API) e as URLs de imagem já resolvidas pelo componente de seção.
 *
 * `variant="empilhado"` (opt-in, usado pelo Intersemanal): em vez de abas que
 * alternam um grupo por vez, mostra todos os grupos empilhados sob uma barra
 * de título full-width, e o título de cada mapa vira uma pill acima da imagem
 * (em vez de legenda abaixo). O DECOMP não passa essa prop e mantém o
 * comportamento de abas (`variant="tabs"`, default) intocado.
 */
export default function MapaGaleria({
  grupos,
  variant = 'tabs',
}: {
  grupos: MapaGrupo[];
  variant?: 'tabs' | 'empilhado';
}) {
  const [ativo, setAtivo] = useState(0);
  // Clampa o índice caso `grupos` encolha (refetch com menos grupos) — evita
  // sub-aba "órfã" sem destaque e galeria vazia.
  const ativoEfetivo = Math.min(ativo, grupos.length - 1);
  const grupo = grupos[ativoEfetivo];

  if (variant === 'empilhado') {
    return (
      <div className="mapa-galeria mapa-galeria--empilhado">
        {grupos.map((g) => (
          <div key={g.nome} className="mapa-galeria__secao">
            {grupos.length > 1 && (
              <div className="mapa-galeria__secao-titulo">{g.nome}</div>
            )}
            <div className="mapa-galeria__grade">
              {g.mapas.map((mapa) => (
                <figure key={mapa.imagem_url} className="mapa-galeria__item mapa-galeria__item--empilhado">
                  <figcaption>{mapa.titulo}</figcaption>
                  <img src={mapa.imagem_url} alt={mapa.alt} loading="lazy" />
                </figure>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mapa-galeria">
      {grupos.length > 1 && (
        <div className="mapa-galeria__tabs">
          {grupos.map((g, i) => (
            <button
              key={g.nome}
              type="button"
              aria-pressed={i === ativoEfetivo}
              className={`mapa-galeria__tab${i === ativoEfetivo ? ' mapa-galeria__tab--ativo' : ''}`}
              onClick={() => setAtivo(i)}
            >
              {g.nome}
            </button>
          ))}
        </div>
      )}
      <div className="mapa-galeria__grade">
        {grupo?.mapas.map((mapa) => (
          <figure key={mapa.imagem_url} className="mapa-galeria__item">
            <img src={mapa.imagem_url} alt={mapa.alt} loading="lazy" />
            <figcaption>{mapa.titulo}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
